(function (angular) {
    'use strict';

    angular
        .module('app')
        .factory('HeartbeatApi', HeartbeatApi);

    HeartbeatApi.$inject = [
        '$resource'
    ];

    function HeartbeatApi($resource) {

        var url = '/api/heartbeat',
            actions;

        actions = {};

        return $resource(url, {}, actions);
    }

}(angular));